// extracted by mini-css-extract-plugin
module.exports = {"black-overlay":"BlackOverlay_black-overlay__1Tyks","hide":"BlackOverlay_hide__1b0fT"};